import { render, staticRenderFns } from "./document-table-component.vue?vue&type=template&id=4fc03d94&scoped=true&lang=pug"
import script from "./document-table-component.js?vue&type=script&lang=js&external"
export * from "./document-table-component.js?vue&type=script&lang=js&external"
import style0 from "./document-table-component.vue?vue&type=style&index=0&id=4fc03d94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc03d94",
  null
  
)

export default component.exports